<template>
  <div v-if="levelChanges">
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
          <div class="vx-row">
            <div class="vx-col lg:w-1/5 mb-base">
              <feather-icon
                icon="HomeIcon"
                class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
                svgClasses="h-8 w-8"
              ></feather-icon>
              <h1 class="mb-2 text-white">
                {{ levelChanges.length }}
              </h1>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">All level changes</p>
            </div>
            <div class="vx-col lg:w-1/5 mb-base">
              <feather-icon
                icon="UserIcon"
                class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
                svgClasses="h-8 w-8"
              ></feather-icon>
              <h1 class="mb-2 text-white">{{ numLevelOne }}</h1>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">Level 1 changes</p>
            </div>
            <div class="vx-col lg:w-1/5 mb-base">
              <feather-icon
                icon="UserIcon"
                class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
                svgClasses="h-8 w-8"
              ></feather-icon>
              <h1 class="mb-2 text-white">{{ numLevelTwo }}</h1>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">Level 2 changes</p>
            </div>
            <div class="vx-col lg:w-1/5 mb-base">
              <feather-icon
                icon="UserIcon"
                class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
                svgClasses="h-8 w-8"
              ></feather-icon>
              <h1 class="mb-2 text-white">{{ numLevelThree }}</h1>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">Level 3 changes</p>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <!-- 
    "id": "ca921f1f-d924-4d18-9efb-31327f98b23d",
    "levelTo": 2,
    "levelFrom": 1,
    "reason": "completeNumShifts",
    "userId": "d6ede91c-98ae-4922-aab8-9868dbbb24bb",
    "timestamp": "2021-09-27T11:24:10.261629Z",
    "displayName": "Lucas Schønrock",

-->

    <div class="row">
      <vs-table max-items="100" pagination search :data="levelChanges">
        <template slot="thead">
          <vs-th sort-key="displayName"> Name </vs-th>
          <vs-th sort-key="levelFrom"> Level from </vs-th>
          <vs-th sort-key="levelTo"> Level to </vs-th>
          <vs-th sort-key="reason"> Reason </vs-th>
          <vs-th sort-key="timestamp"> Updated at </vs-th>
          <vs-th sort-key="levelValidFrom"> Level obtained at </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="lc.id" v-for="lc in data">
            <vs-td :data="lc.displayName">
              {{ lc.displayName }}
            </vs-td>

            <vs-td :data="lc.levelFrom">
              {{ lc.levelFrom }}
            </vs-td>

            <vs-td :data="lc.levelTo">
              {{ lc.levelTo }}
            </vs-td>

            <vs-td :data="campusLevelChangeReasonEnum[lc.reason]">
              {{ campusLevelChangeReasonEnum[lc.reason] }}
            </vs-td>

            <vs-td :data="lc.timestamp">
              {{ moment(lc.timestamp).format("YYYY-MM-DD HH:mm:ss") }}
            </vs-td>

            <vs-td :data="lc.levelValidFrom">
              {{ moment(lc.levelValidFrom).format("YYYY-MM-DD HH:mm:ss") }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import moment from "moment";

export default {
  components: {},
  data() {
    return {
      moment,
      campusLevelChangeReasonEnum: {
        1: "Completed playbook",
        2: "Completed enough shifts",
        3: "Attended enough staff meetings",
        4: "Completed performance courses",
      },
    };
  },
  computed: {
    ...mapGetters({
      userId: "users/userId",
      levelChanges: "payrates/campusLevelChanges",
      numLevelOne: "payrates/numLevelOne",
      numLevelTwo: "payrates/numLevelTwo",
      numLevelThree: "payrates/numLevelThree",
    }),
  },
  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("payrates/getCampusLevelChanges");
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
</style>
